import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './SimpleCheckbox.module.scss';

export default class SimpleCheckbox extends Component {
    static propTypes = {
        checked: PropTypes.bool,
        onChange: PropTypes.func,
        status: PropTypes.string
    };

    static defaultProps = { onChange: () => {} };

    onClick = e => {
        const { checked, onChange } = this.props;
        e.stopPropagation();
        onChange(!checked);
    };

    render() {
        const { checked, disabled, dataCy } = this.props;
        return (
            <input type="checkbox" data-cy={dataCy ? dataCy : 'simple-checkbox'} data-testid="simple-checkbox" className={classNames(s.container, { [s.selected]: checked })} onClick={this.onClick} checked={checked} disabled={disabled ? disabled : false} />
        );
    }
}
